import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import plusIcon from '../../../assets/img/icons/plus_white.svg';
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from '../../../styledComponents/buttons';
import {
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../../styledComponents/common';
import AddEmtithalMasterTaskModal from './AddEmtithalMasterTaskModal';
import EmtithalMasterTasksFilter from './EmtithalMasterTasksFilter';
import EmtithalMasterTasksList from './EmtithalMasterTasksList';

const EmtithalMasterTasks = ({
  getEmtithalMasterTasks,
  emtithalMasterTasksList,
  editEmtithalMasterTask,
  isLoading,
  getPublicZoneList,
  publicZoneList,
  officesShortList2,
  getOfficesShortList,
  officesShortList,
  addEmtithalMasterTask,
  addTaskLoading,
  getMasterSubTasks,
  masterSubTasksList,
  masterSubTasksLoading,
}) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    publicZone: null,
    office: null,
    taskName: '',
    taskCode: '',
  });
  const [reload, setReload] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  const handleAddOrEditEmtithalMasterTask = payload => {
    if (isEditMode && taskToEdit) {
      editEmtithalMasterTask({
        ...payload,
        task_id: taskToEdit.id,
        callback: () => {
          toggleModal();
          setReload(prev => !prev);
        },
      });
    } else {
      addEmtithalMasterTask({
        ...payload,
        callback: () => {
          toggleModal();
          setReload(prev => !prev);
        },
      });
    }
  };

  const toggleModal = () => {
    setIsModalOpen(prev => !prev);
    if (isModalOpen) {
      setIsEditMode(false);
      setTaskToEdit(null);
    }
  };

  const handleEditTask = task => {
    setTaskToEdit(task);
    setIsEditMode(true);
    setIsModalOpen(true);
  };

  useEffect(() => {
    getPublicZoneList();
  }, [getPublicZoneList]);

  useEffect(() => {
    const payload = {};
    if (filters?.publicZone?.value) {
      payload.public_zone_id = filters.publicZone.value;
    }
    if (filters?.office?.value) {
      payload.office_id = filters.office.value;
    }
    if (filters?.taskName) {
      payload.name = filters.taskName;
    }
    if (filters?.taskCode) {
      payload.code = filters.taskCode;
    }
    getEmtithalMasterTasks(payload);
  }, [getEmtithalMasterTasks, filters, reload]);

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('emtithal_master_tasks')}</PageTitle>
        <ColoredButtonWithIcon
          onClick={() => {
            setIsEditMode(false);
            setTaskToEdit(null);
            toggleModal();
          }}
        >
          <ButtonIcon src={plusIcon} alt="" />
          {t('create_task')}
        </ColoredButtonWithIcon>
      </CommonGrid>
      <HeaderContainer>
        <EmtithalMasterTasksFilter
          publicZoneList={publicZoneList}
          getOfficesShortList={getOfficesShortList}
          officesShortList={officesShortList}
          handleSearchByName={() => {}}
          handleClearSearch={() => {}}
          onFilterChange={setFilters}
        />
      </HeaderContainer>
      <EmtithalMasterTasksList
        emtithalMasterTasksList={emtithalMasterTasksList}
        editEmtithalMasterTask={handleEditTask}
        isLoading={isLoading}
        publicZoneList={publicZoneList}
      />
      <AddEmtithalMasterTaskModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        publicZoneList={publicZoneList}
        officesShortList={officesShortList2}
        getOfficesShortList={params =>
          getOfficesShortList({ ...params, secondApi: true })
        }
        addEmtithalMasterTask={handleAddOrEditEmtithalMasterTask}
        editEmtithalMasterTask={handleAddOrEditEmtithalMasterTask}
        isLoading={addTaskLoading}
        reload={reload}
        setReload={setReload}
        isEditMode={isEditMode}
        taskToEdit={taskToEdit}
        getMasterSubTasks={getMasterSubTasks}
        masterSubTasksList={masterSubTasksList}
        masterSubTasksLoading={masterSubTasksLoading}
      />
    </div>
  );
};

export default EmtithalMasterTasks;
